/** 予約表の shareUrl からフロントのパス（/reservations/share/...）を得る */
export function reservationBoardSharePath(shareUrl: string | null | undefined): string | null {
  if (!shareUrl?.trim()) return null;
  try {
    return new URL(shareUrl).pathname;
  } catch {
    const trimmed = shareUrl.trim();
    if (trimmed.startsWith('/reservations/share/')) return trimmed;
    return null;
  }
}

type ShareBoardTitleListener = () => void;

let rsShareBoardTitle = '';
const rsShareBoardTitleListeners = new Set<ShareBoardTitleListener>();

/** 共有ページの最小バーに表名を出す（Layout ↔ カレンダー橋渡し） */
export function setRsShareBoardTitle(title: string): void {
  const next = title.trim();
  if (rsShareBoardTitle === next) return;
  rsShareBoardTitle = next;
  rsShareBoardTitleListeners.forEach((listener) => listener());
}

export function getRsShareBoardTitle(): string {
  return rsShareBoardTitle;
}

export function subscribeRsShareBoardTitle(listener: ShareBoardTitleListener): () => void {
  rsShareBoardTitleListeners.add(listener);
  return () => {
    rsShareBoardTitleListeners.delete(listener);
  };
}
